import React from 'react';

export default function LogoutKakao() {
  return (
    <div>
      
    </div>
  )
}
